import { render, staticRenderFns } from "./FullScreenMenu.vue?vue&type=template&id=bd8addc2"
import script from "./FullScreenMenu.vue?vue&type=script&lang=js"
export * from "./FullScreenMenu.vue?vue&type=script&lang=js"
import style0 from "./FullScreenMenu.vue?vue&type=style&index=0&id=bd8addc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports